import { render, staticRenderFns } from "./resolution_table.vue?vue&type=template&id=8c682be6&scoped=true&"
import script from "./resolution_table.vue?vue&type=script&lang=js&"
export * from "./resolution_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c682be6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c682be6')) {
      api.createRecord('8c682be6', component.options)
    } else {
      api.reload('8c682be6', component.options)
    }
    module.hot.accept("./resolution_table.vue?vue&type=template&id=8c682be6&scoped=true&", function () {
      api.rerender('8c682be6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/action/tabs/resolution/table/resolution_table.vue"
export default component.exports